export default "__VITE_ASSET__rbDMeaZa__"